module.exports = __webpack_public_path__ + "img/promostar.2f51e9ca.webp";